<template>
  <div class="content-wrapper" @edit="refresh">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('task')"
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>
      <!-- <div class="col-sm-12 col-md-6 breadcrumb-side-button">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openAddEditModal"
          >
            {{ $t("bid") }}
          </button>
        </div>
      </div> -->
    </div>
    <div class="card card-with-search border-0 card-with-shadow">
      <div class="text-justify">
        <app-tab :tabs="tabsHorizontal" type="horizontal"/>
      </div>
    </div>
  </div>
</template>
<script>
import CopyButton from "../../Demo/UI/CopyButton.vue";

export default {
  name: "Tabs",
  components: { CopyButton },
  props: {
    id: Number,
    edit: Function,
  },
  data() {
    return {
      icon: "settings",
      id: 0,
      isAddEditModalActive: false,
      tabsHorizontal: [
        {
          icon: "info",
          name: "Update Task",
          component: "task-taskedit",
          permission: '',
          props: {id:this.id, fun:this.edit}
        },
        {
          icon: "link",
          name: "Forms",
          component: "task-form-mainstep",
          permission: '',
          // props: {id:this.getData()}
          props: {id:this.id}
        },
      ],
    };
  },
    methods: {

      // getData() {
       
      // let myLocation = location.href;
      // let split = myLocation.split("/");
      // let id = split[6].split("?")[0];
      // return id;
      // }
    }
};
</script>
